import { SINGLE_BLOG_ID } from "./Blog";

export const initialBlogInformation = {
  blog_id: null,
};

const blogReducer = (state = initialBlogInformation, action) => {
  console.log("###############  Blog Reducer  ###############");
  console.log("Action: ", action);
  console.log("State: ", state);
  switch (action.type) {
    case SINGLE_BLOG_ID:
      return {
        ...state,
        blog_id: action.blog_id,
      };
    default:
      // console.log("UAM DEFAULT")
      return initialBlogInformation;
  }
};

export default blogReducer;
